module.exports = __webpack_public_path__ + "static/10kt-diamond-star-hoop-earrings-e0a5e008c99310173cc14b18347069fb.jpg";